import {TextToolTip} from "components";
import {DeleteActionBtn, EditActionBtn} from "components";
import {
    currentLegStatusData,
    currentLegTypeData,
    EscortAppPatientStatuses,
    RateTypes,
    RateTypesForTable,
    SexTypes
} from "fragments";
import {Statuses} from "./fragments";
import {Svg} from "../../assets";
import {renderPayerName} from "utils";

export const PatientTypesEnum = {
    HOME: "HOME",
    SNF: "SNF",
    ACUTE: "ACUTE",
};

export const PatientTypes = {
    HOME: "Home",
    SNF: "SNF",
    ACUTE: "Acute",
};

export const PatientTypesList = [
    {
        id: PatientTypesEnum.HOME,
        name: PatientTypes.HOME,
    },

    {
        id: PatientTypesEnum.SNF,
        name: PatientTypes.SNF,
    },

    {
        id: PatientTypesEnum.ACUTE,
        name: PatientTypes.ACUTE,
    },
];


export const ACTION_TYPE_GET_LEGS = 'GET_LEGS'
export const ACTION_TYPE_GET_LEGS_SUCCESS = 'GET_LEGS_SUCCESS'

export const patientDetails = (item) => {
    return [
        {
            list: [
                {
                    title: "General Info",
                    list: [
                        {
                            title: "Last Name",
                            desc: item?.lastName,
                        },
                        {
                            title: "First Name",
                            desc: item?.firstName,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Middle Name",
                            desc: item?.middleName,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "DOB",
                            desc: item?.dob,
                            dateRow: true,
                        },

                        {
                            title: "Sex",
                            desc: SexTypes[item?.sex],
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Weight",
                            desc: `${item?.weight ? item?.weight + 'Ibs' : '--'}`,
                        },

                        {
                            title: "Height",
                            desc: `${item?.height ? item?.height : '--'}`,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Phone Number",
                            desc: item?.phone,
                            phoneRow: true,
                        },
                        {
                            title: "Secondary Phone",
                            desc: `${item?.secondaryPhone ? item?.secondaryPhone : '--'}`,
                            phoneRow: item?.secondaryPhone,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "MRN",
                            desc: `${item?.mrnNumber ? item?.mrnNumber : '--'}`,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Subject",
                            desc: `${item?.subject ? item?.subject : '--'}`,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Level of Service",
                            desc: RateTypes[item?.los],
                        },

                        {
                            title: "Insurance",
                            desc: renderPayerName(item?.insurance),
                        },
                    ],
                },
            ],
        },
        {
            list: [
                {
                    title: "Address",
                    list: [
                        {
                            title: "Street",
                            desc: item?.address?.street,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Unit/Suit #",
                            desc: item?.address?.unitNumber,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "City",
                            desc: item?.address?.city,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "State",
                            desc: item?.address?.state,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Country",
                            desc: item?.address?.country,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Zip Code",
                            desc: item?.address?.zip,
                        },
                    ],
                },
            ],
        },
    ];
};

export const patientsHead = () => {
    return [
        {title: "Last Name", name: "lastName", searchKey: "lastName"},
        {title: "First Name", name: "firstName", searchKey: "firstName"},
        {title: "Middle Name", name: "middleName", searchKey: "middleName"},
        {title: "MRN", name: "mrnNumber", searchKey: "mrnNumber", sortType: 'mrnNumber'},
        {title: "Payer", name: "payer", searchKey: "payer", custom: false},
        {title: "DOB", name: "dob", disabled: true, sortType: "dob"},
        {title: "Last Trip", name: "lastTrip", sortType: "lastTrip", custom: false},
        {
            title: "Status",
            name: "status",
            disabled: true,
            filterList: [{name: "All", id: "All"}, ...PatientTypesList],
            width: 149,
        },
        {title: "Action", custom: false, width: "88px"},
    ];
};

export const patientsBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip text={item?.lastName} content={item?.lastName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.firstName} content={item?.firstName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.middleName} content={item?.middleName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.mrnNumber} content={item?.mrnNumber}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={renderPayerName(item?.insurance)} content={renderPayerName(item?.insurance)}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.dob} content={item?.dob} dateRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.lastTripDate} content={item?.lastTripDate} dateRow/>
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    <DeleteActionBtn onClick={() => handleDelete(item)}/>
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addPatient) => {
    return {
        emptyBtnText: 'Add Patient',
        notTitleText: 'No patients added yet',
        notDescText: 'Add your first patient to begin managing their information and related trips.',
        EmptySvg: Svg.EmptyPatients,
        clickToEmptyAddButton: () => addPatient(),
    }
}

export const patientTripsHead = [
    {title: "TP", custom: false},
    {title: "LOS", name: "", searchKey: "", custom: false},
    {title: "DOS", name: "", searchKey: "", custom: false, width: 100},
    {
        title: "Status", name: "status", disabled: true,
        // filterList: EscortAppPatientList,custom: false,width: 121,
    },
    {title: "MLS", name: 'distance', custom: false},
    {title: "Mi.Rate", name: '', custom: false, width: 70},
    {title: "Call Rate", name: '', custom: false, width: 70},
    {title: "Payor", name: 'payer', rowName: ['displayName', 'name'], custom: false},
    {title: "Origin", name: "", custom: false},
    {title: "City", name: "", custom: false},
    {title: "Zip", name: "", custom: false},
    {title: "Dest.", name: "", custom: false},
    {title: "City", name: "", custom: false},
    {title: "Zip", name: "", custom: false},
];


export const patientTripsBody = [
    {
        rowText: (item) => (
            <TextToolTip
                showTooltip
                arrow
                text={item?.type ? currentLegTypeData[item?.type].svg : ''}
                content={item?.type ? currentLegTypeData[item?.type].textTooltip : ''}
                textStyles={{
                    width: 'fit-content',
                    display: 'flex',
                }}
                wrapperStyles={{
                    width: 'fit-content',
                    margin: 'auto',
                    display: 'flex',
                }}
            />
        ),
        width: 60,
        minWidth: 60,
        styles: {padding: 0}
        ,
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={RateTypesForTable[item?.los ?? item?.patient?.los]}
                content={RateTypesForTable[item?.los ?? item?.patient?.los]}
                wrapperStyles={{
                    width: 'fit-content',
                    margin: 'auto',
                }}
            />
        ),
        width: 58,
        minWidth: 58,
    },

    {
        rowText: (item) => (
            <TextToolTip
                text={item?.serviceDate}
                content={item?.serviceDate}
                dateRow
            />
        ),
    },
    {
        rowText: (item) => (
            <div className='flex-all-center' style={{gap: 4}}>
                <TextToolTip
                    classNameWrapper='dispatch-board-table-statuses-wrapper'
                    text={EscortAppPatientStatuses[item?.status]}
                    content={EscortAppPatientStatuses[item?.status]}
                    wrapperStyles={{
                        width: 'fit-content',
                        background: item?.status ? currentLegStatusData?.[item?.status]?.backgroundColor : '',
                    }}
                    textStyles={{
                        width: 'fit-content',
                        color: item?.status ? currentLegStatusData?.[item?.status]?.color : ''
                    }}
                />

                {item?.isDuplicate &&
                    <TextToolTip
                        content='This trip appears to be a duplicate (same patient, date, origin, and destination)'
                        text={<Svg.CopySvg/>}
                        arrow
                        placement='right'
                        showTooltip
                        textStyles={{
                            display: 'flex',
                        }}
                        wrapperStyles={{
                            width: 'fit-content',
                        }}
                    />
                }
            </div>
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
                content={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
            />
        ),
    },
    {
        rowText: (item) => {
            return (
                <TextToolTip
                    text={item?.callRevenue}
                    content={item?.callRevenue}
                    priceRow
                />
            )
        },
    },
    {
        rowText: (item) => {
            return (
                <TextToolTip
                    text={item?.revenue}
                    content={item?.revenue}
                    priceRow
                />
            )
        },
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={renderPayerName(item?.payer)}
                content={renderPayerName(item?.payer)}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.pickUp?.address?.street}
                content={item?.dropOff?.address?.street}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.pickUp?.address?.city}
                content={item?.pickUp?.address?.city}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.pickUp?.address?.zip}
                content={item?.pickUp?.address?.zip}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.dropOff?.address?.street}
                content={item?.dropOff?.address?.street}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.dropOff?.address?.city}
                content={item?.dropOff?.address?.city}
            />
        ),
    },
    {
        rowText: (item) => (
            <TextToolTip
                text={item?.dropOff?.address?.zip}
                content={item?.dropOff?.address?.zip}
            />
        ),
    },
];


export const emptyStatePatientTrips = {
    notTitleText: 'No trips yet',
    EmptySvg: Svg.EmptyPatients,
}
